import PerformanceHelper from '../helpers/performance_helper';

// Report page load performance to Gusto Analytics after 5 seconds.
const performanceHelper = new PerformanceHelper();
performanceHelper.executeFunctionOnLoad(function() {
  const data = performanceHelper.getPageLoadInformation();

  if (data === null) {
    return;
  }

  const pageLoad = {
    eventCategory: 'GustoPerformance',
    eventName: 'PageLoad',
    data: data.pageLoad,
  };

  const navigationTime = {
    eventCategory: 'GustoPerformance',
    eventName: 'NavigationTime',
    data: data.navigationTime,
  };

  /**
   * Safety helper to avoid duplication of code
   *
   * @param reportTo          Object to report data to
   * @param payload           The payload to report
   * @param trackingMethod   Whether to use track or push
   */
  const report = function(reportTo, payload, trackingMethod) {
    if (!reportTo || !payload || !payload.data) {
      return;
    }

    try {
      if (trackingMethod) {
        reportTo.track(payload);
      } else {
        reportTo.push(payload);
      }
    } catch (e) {
      Bugsnag.notify(new Error('This is a handled error. Just FYI.'), {
        metaData: { exception: e },
      });
      console.error(e);
    }
  };

  console.log('Reporting performance metrics now');
  console.debug(`Reporting page load to Gusto Analytics, Optimizely`);

  report(window.GustoAnalytics, pageLoad, true);
  report(window.optimizelyFSClient, pageLoad, true);

  // Report Optimizely Web differently as required
  report(
    window.optimizely,
    {
      type: 'event',
      eventName: 'GustoPerformance-PageLoad',
      tags: data.pageLoad,
    },
    false
  );

  console.debug(`Reporting page navigation to Gusto Analytics and Optimizely`);

  report(window.GustoAnalytics, navigationTime, true);
  report(window.optimizelyFSClient, navigationTime, true);

  // Report Optimizely Web differently as required
  report(
    window.optimizely,
    {
      type: 'event',
      eventName: 'GustoPerformance-NavigationTime',
      tags: data.navigationTime,
    },
    false
  );
}, null);
